import React from 'react';
import { Box, List, ListItem } from '@mui/joy';
import { useTranslation } from 'react-i18next';

const CellCommaSeparatedList = ({ type, value, field, splitcharacter, translate = true }) => {
    const { t } = useTranslation();
    const values = typeof value === 'string' && splitcharacter
        ? value.split(splitcharacter ?? ',')
        : Array.isArray(value)
            ? value
            : [];
    const visibleValues = values.filter(item => item != null && item !== '');

    if (visibleValues.length === 0) return null;

    return (
        <Box className={"list-element-cell cell-generics cell-generics-"+type}>
            <List className="cell-generics-list">
                {visibleValues.map((item, k) => (
                    <ListItem key={k} className={'cell-generics-list-item cell-generics-list-item-action '+item}>
                        <span className="name" title={translate ? t(item) : item}>{translate ? t(item) : item}</span>
                    </ListItem>
                ))}
            </List>
        </Box>
    )
    
}

export default CellCommaSeparatedList;